export default __webpack_public_path__ + "static/media/2022.c8edc51d.png";